import React from 'react';
import ContainersList from '../modules/containers/List';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import config from 'src/config';
import containerMethods from 'src/methods/container.methods';

export default class ContainersPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			role: localStorage.getItem('role') || config.USER_ROLES.USER,
			value: 'containers'
		};
	}

	render() {
		return (

			<TabContext value={this.state.value}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<TabList onChange={(e, value) => {
						this.setState({ value });
					}} aria-label="lab API tabs example">
						<Tab label="Groups" value="containers" icon={containerMethods.getContainerIcon({ type: "container" })} iconPosition="start"/>
						{(this.state.role != config.USER_ROLES.USER) ? (
							<Tab label="Departments" value="departments" icon={containerMethods.getContainerIcon({ type: "department" })} iconPosition="start"/>
						) : null}
						{(this.state.role != config.USER_ROLES.USER) ? (
							<Tab label="Teams" value="teams" icon={containerMethods.getContainerIcon({ type: "team" })} iconPosition="start"/>
						) : null}
						{(this.state.role != config.USER_ROLES.USER) ? (
							<Tab label="Projects" value="projects" icon={containerMethods.getContainerIcon({ type: "project" })} iconPosition="start"/>
						) : null}
					</TabList>
				</Box>
				<TabPanel value="containers">
					<ContainersList
						payload={{
							type: 'container'
						}}
					/>
				</TabPanel>
				<TabPanel value="departments">
					<ContainersList
						payload={{
							type: 'department'
						}}
					/>
				</TabPanel>
				<TabPanel value="teams">
					<ContainersList
						payload={{
							type: 'team'
						}}
					/>
				</TabPanel>
				<TabPanel value="projects">
					<ContainersList
						payload={{
							type: 'project'
						}}
					/>
				</TabPanel>
			</TabContext>
		);
	}
}
